import { Api } from "./Api.class";
const endpoint = "campaigns";
const campaignsAPI = new Api(endpoint);
export default campaignsAPI;
